import React from 'react';
import { CartProps, cn, ReserveButtonStages } from 'types';
import { CartHeader } from './CartHeader';
import { CartSummary } from './CartSummary';
import { CartFooter } from './CartFooter';

export function Cart({
  make,
  modelSeries,
  image,
  showEquipmentListLink,
  onOpenEquipmentList,
  headerChildren,
  showVehicleImage = true,
  isUsedImportCar,
  model,
  reRegistrationFee,
  totalPrice,
  onReRegistrationFeeChange,
  onTotalPriceChange,
  oneOffTaxAndWreckage,
  onOneOffTaxChange,
  accessoryTax,
  data,
  prices,
  isElectricCar = true,
  equipmentDetails,
  oneOffTaxAndWreckageDetails,
  rammeavtale,
  bruksKodeTag,
  oneOffTaxChildren,
  vehicleCount = 0,
  location,
  status,
  serialNo,
  selectedStatus,
  vehicleTTCode,
  selectedLocation,
  isShowFooter = true,
  isAllowOffer = false,
  isVehicleSelected = false,
  isFactoryOrder = false,
  reserveButtonStage = ReserveButtonStages.NO_RESERVE_REQUEST,
  isFactoryOrderEnable = false,
  isFilterAllow = false,
  isSelectedVehicleUnavailable = false,
  expectedProductionDate,
  onOpenVehicleList,
  onReserveVehicle,
  onSaveOfferPDF,
  onSelectLocation,
  onSelectStatus,
  onSaveFactoryOrder,
  isLoading = false,
  showReserveButton,
  vehicleCountBySeller,
  onSellerChangeByCount,
  showChangeSpecificCarButton,
  isProdDateDisabled,
  footerChildren,
  exactMatchCount,
  nonExactMatchCount,
  showAbortFactoryOrderAction,
  abortFactoryBorder,
  reservationInfoText,
  isFactoryOrderButtonDisabled,
  showReservationInfo,
  reservationToDateLabel,
  isIFSReservationInProgress,
  orderType,
}: CartProps) {
  return (
    <div
      className={cn(
        'bg-white h-full max-w-[calc(100vw-5rem)] min-h-[calc(100vh-2*var(--app-header-height))]',
        'relative transition-transform duration-200 ease-in-out'
      )}
    >
      <div className="border w-full border-neutralGrey rounded-lg sticky top-[12rem] right-0">
        <CartHeader
          make={make}
          modelSeries={modelSeries}
          image={image}
          showEquipmentListLink={showEquipmentListLink}
          onOpenEquipmentList={onOpenEquipmentList}
          headerChildren={headerChildren}
          showVehicleImage={showVehicleImage}
          isUsedImportCar={isUsedImportCar}
        />
        <CartSummary
          model={model}
          reRegistrationFee={reRegistrationFee}
          totalPrice={totalPrice}
          onReRegistrationFeeChange={onReRegistrationFeeChange}
          onTotalPriceChange={onTotalPriceChange}
          oneOffTaxAndWreckage={oneOffTaxAndWreckage}
          onOneOffTaxChange={onOneOffTaxChange}
          isUsedImportCar={isUsedImportCar}
          accessoryTax={accessoryTax}
          data={data}
          prices={prices}
          isElectricCar={isElectricCar}
          equipmentDetails={equipmentDetails}
          oneOffTaxAndWreckageDetails={oneOffTaxAndWreckageDetails}
          rammeavtale={rammeavtale}
          bruksKodeTag={bruksKodeTag}
          oneOffTaxChildren={oneOffTaxChildren}
        />
        <CartFooter
          orderType={orderType}
          vehicleCount={vehicleCount}
          location={location}
          status={status}
          serialNo={serialNo}
          selectedStatus={selectedStatus}
          vehicleTTCode={vehicleTTCode}
          selectedLocation={selectedLocation}
          isShowFooter={isShowFooter}
          isAllowOffer={isAllowOffer}
          isVehicleSelected={isVehicleSelected}
          isFactoryOrder={isFactoryOrder}
          reserveButtonStage={reserveButtonStage}
          isFactoryOrderEnable={isFactoryOrderEnable}
          isFilterAllow={isFilterAllow}
          isSelectedVehicleUnavailable={isSelectedVehicleUnavailable}
          expectedProductionDate={expectedProductionDate}
          onOpenVehicleList={onOpenVehicleList}
          onReserveVehicle={onReserveVehicle}
          onSaveOfferPDF={onSaveOfferPDF}
          onSelectLocation={onSelectLocation}
          onSelectStatus={onSelectStatus}
          onSaveFactoryOrder={onSaveFactoryOrder}
          isLoading={isLoading}
          showReserveButton={showReserveButton}
          vehicleCountBySeller={vehicleCountBySeller}
          onSellerChangeByCount={onSellerChangeByCount}
          showChangeSpecificCarButton={showChangeSpecificCarButton}
          isProdDateDisabled={isProdDateDisabled}
          footerChildren={footerChildren}
          exactMatchCount={exactMatchCount}
          nonExactMatchCount={nonExactMatchCount}
          showAbortFactoryOrderAction={showAbortFactoryOrderAction}
          abortFactoryBorder={abortFactoryBorder}
          reservationInfoText={reservationInfoText}
          showReservationInfo={showReservationInfo}
          reservationToDateLabel={reservationToDateLabel}
          isFactoryOrderButtonDisabled={isFactoryOrderButtonDisabled}
          isIFSReservationInProgress={isIFSReservationInProgress}
        />
      </div>
    </div>
  );
}
